import { useContext, useEffect, useState } from "react";
import { useDateFormatter } from '../../../Utils/DateFormatter';
import { Stack } from "@fluentui/react/lib/Stack";
import {
  Breadcrumb,
  Checkbox,
  ComboBox,
  DatePicker,
  FontSizes,
  FontWeights,
  IBreadcrumbItem,
  IComboBox,
  IComboBoxOption,
  Icon,
  Label,
  MessageBar,
  MessageBarType,
  PrimaryButton,
} from "@fluentui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDateToMMDDYYYY } from "../../../Utils/DateFormatUtility";
import React from "react";
import "../../CustomerAccount/CustomerAccountStyle.css";
import {
  SaveButtonStyleShipping,
  EditScreenButtonStyle,
  DiscountCalendarStyles,
  ComboBoxStyles,
  CheckBoxStyles,
  CreateQuoteStyle,
  DiscountComboBoxStyles,
} from "../CustomerStyle";
import { ICustomerAccountsProps } from "../Customer.types";
import { intialCustomerInfo } from "../CustomerContext";
import {
  businessEducationAffiliation,
  discountReasonsOptions,
  minumDiscountOptions,
  taxExemptReasonsOptions,
} from "../CustomerFormInitialValues";

import { CustomerDiscount } from "../Customer.types";
import { CustomerService } from "../../../services/Customers/CustomerService";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import {
  AFFILATION_REQUIRED,
  validateCustomerDiscountSetupFields,
} from "./AddCustomerDiscountValidation";
import {
  ErrorsDefaultState,
  InitialQuotationInfo,
  InitialStateOfResponseMessage,
  NEW_ACTION,
} from "../../Quotation/Common/QuotationData";
import {
  Card,
  CardStandardHeader,
  LoadingState,
} from "@coherence-design-system/controls";
import { stackTokensWithGap20 } from "../../Quotation/QuotationStyle";
import {
  BreadcrumbStyle,
  LoadingContainerStyle,
} from "../../Quotation/AddQuotation/AddQuotationStyle";
import "./Discount.css";
import { QuotationContext } from "../../Quotation/QuotationContext";
import {
  IQuotationType,
  IResponseMessage,
  QuotationInfoType,
} from "../../Quotation/Quotation.types";

const AffilationChecked = {
  businessEducation: false,
  businessGovernment: false,
  businessMilitary: false,
  businessGeneral: false,
};
const ContractChecked = {
  dealRegistration: false,
  specialPricing: false,
  coopPricing: false,
};

const CustomerGroupChecked = {
  governmentNoDiscount: false,
  employeePricing: false,
};

const TaxExemptChecked = {
  isTaxExemptChecked: false,
};

const intialDiscountValue: CustomerDiscount = {
  afilliationSelected: "",
  contract: [],
  taxExempt: {
    isTaxExemptChecked: false,
    expirationDate: "",
    taxExemptReason: "",
  },
  customerGroup: {
    governmentDiscountSelected: false,
    employeePricingSelected: false,
    couponCode: [],
  },
  restrictedSkus: "",
};

export const CustomerDiscountSetup: React.FunctionComponent<
  ICustomerAccountsProps
> = (props) => {
  const navigate = useNavigate();
  const appInsights = useAppInsightsContext();
  const location = useLocation();
  const intialParams: any = location && location?.state;
  const params = intialParams?.editCustomer;
  // Get country from params or customerDiscount if available
  const countryName = (params?.country || params?.customer?.country || params?.customerCountry || "") ?? "";
  const { formatDate: formatDateCountry } = useDateFormatter(countryName);
  const [customerDiscount, setDiscountValue] = useState(intialDiscountValue);
  const [affiliationCheckBox, setAffiliationCheckbox] =
    useState(AffilationChecked);
  const [contractCheckBox, setContractCheckbox] = useState(ContractChecked);
  const [customerGroupCheckBox, setCustomerGroupCheckBox] =
    useState(CustomerGroupChecked);
  const [taxExemptCheckBox, setTaxExemptCheckBox] = useState(TaxExemptChecked);
  const [dealRegistrationExpirationDate, setDealRegistrationExpirationDate] =
    useState<Date | undefined>(undefined);
  const [specialPricingExpirationDate, setSpecialPricingExpirationDate] =
    useState<Date | undefined>(undefined);
  const [coopPricingExpirationDate, setcoopPricingExpirationDate] = useState<
    Date | undefined
  >(undefined);
  const [taxExemptExpirationDate, setTaxExemptExpirationDate] = useState<
    Date | undefined
  >(undefined);
  const [coopMinimumDiscount, setCoopMinimumDiscount] = useState("");
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [isNewQuoteButtonDisabled, setIsNewQuoteButtonDisabled] =
    useState(true);
  const [customerDiscountError, setCustomerDiscountError] = useState(
    intialCustomerInfo?.discount
  );
  const [isTaxExemptReasonSelected, setIsTaxExemptReasonSelected] =
    useState(false);

  const { setQuotationInfo } = useContext(
    QuotationContext
  ) as QuotationInfoType;
  const { setQuotationError } = useContext(QuotationContext) as IQuotationType;

  const cardStyle = {
    backgroundColor: "rgb(241, 241, 241)", 
  };
  const customerDiscountComboBoxStyle = {
    root: {
      width: 220,
    },
    callout: { width: "500px", height: "290px" },
  };
  const [loader, setLoader] = useState({ isLoading: false, message: "" });

  let minimumDiscountEnabled = customerDiscount.contract.some(
    (x) => x.contractSelected === "CO-OP Pricing"
  );
  const isGovernmentExcludedDisabled =
    affiliationCheckBox.businessEducation ||
    affiliationCheckBox.businessGeneral ||
    affiliationCheckBox.businessMilitary;
  const [dealRegExpriationDateWarning, setDealRegExpriationDateWarning] =
    useState("");
  const [
    specialPricingExpriationDateWarning,
    setSpecialPricingExpriationDateWarning,
  ] = useState("");
  const [
    coopPricingExpriationDateWarning,
    setCoopPricingExpriationDateWarning,
  ] = useState("");

  const [taxExemptExpriationDateWarning, setTaxExemptExpriationDateWarning] =
    useState("");

  const [isEmployeePricingDisabled, setIsEmployeePricingisabled] =
    useState(false);
  const [customerSuccessMessage, setCustomerSuccessMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);
  const [customerFailureMessage, setCustomerFailureMessage] =
    useState<IResponseMessage>(InitialStateOfResponseMessage);

  // Use country-selected date formatter for expiration dates
  const formatDate = (date: Date | undefined) => {
    if (!date) return "";
    try {
      return formatDateCountry(date);
    } catch {
      // fallback to dd-mm-yyyy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear());
      return `${day}-${month}-${year}`;
    }
  };

  useEffect(() => {
    props.onCustomerAccount(true);
  }, []);

  const warningMessage = "Please select date";
  const expirationMessage = "Contract Expired";
  const isExpirationDateMissing =
    dealRegExpriationDateWarning === warningMessage ||
    dealRegExpriationDateWarning === expirationMessage ||
    coopPricingExpriationDateWarning === warningMessage ||
    coopPricingExpriationDateWarning === expirationMessage ||
    specialPricingExpriationDateWarning === warningMessage ||
    specialPricingExpriationDateWarning === expirationMessage ||
    taxExemptExpriationDateWarning === warningMessage;

  const isTaxExemptyReason =
    taxExemptCheckBox;

  const isExpired = (contractDate: Date | undefined, isTaxExempt = false) => {
    const todayDate = new Date();
    const existingContractDate = contractDate;
    if (existingContractDate === undefined) {
      return "Please select date";
    }
    if (
      existingContractDate &&
      existingContractDate.setHours(0, 0, 0, 0) ===
        todayDate.setHours(0, 0, 0, 0)
    ) {
      return isTaxExempt
        ? "Alert: Tax Exempt Expiring Today"
        : "Alert: Contract Expiring Today";
    }
    if (
      existingContractDate &&
      existingContractDate.setHours(0, 0, 0, 0) > todayDate.setHours(0, 0, 0, 0)
    ) {
      const timeDifference =
        existingContractDate.getTime() - todayDate.getTime();
      const daysDifference = Math.abs(
        Math.floor(timeDifference / (1000 * 60 * 60 * 24))
      );
      if (daysDifference < 30) {
        return isTaxExempt
          ? "Alert: Tax Exempt Expiring in less than 30 days"
          : "Alert: Contract Expiring in less than 30 days";
      }
      return "";
    } else {
      return isTaxExempt ? "Alert: Tax Exempt Expired" : "Contract Expired";
    }
  };

  const isEditFlow = intialParams?.isEditFlow;

  const getBreadcrumbItems = () => {
    const items: IBreadcrumbItem[] = [
      {
        text: "Customers",
        key: "Customers",
        onClick: () => {
          navigate("/Customer");
        },
      },
      {
        text: isEditFlow ? `Edit Account` : `New Account`,
        key: isEditFlow ? `Edit Account` : `New Account`,
        onClick: () => {
          isEditFlow
            ? navigate("/CustomerEditContact", { state: params })
            : navigate("/CustomerNewAccount");
        },
      },
      {
        text: `Discount`,
        key: `Discount`,
      },
    ];
    if (params?.name) {
      items.push({
        text: params?.name,
        key: params?.name,
        isCurrentItem: true,
      });
    }
    return items;
  };

  const useScreenScale = () => {
    const [screenScale, setScreenScale] = useState(window.devicePixelRatio);

    useEffect(() => {
      const handleResize = () => {
        setScreenScale(window.devicePixelRatio);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return screenScale;
  };

  let cardSize = {
    width: "800px",
    paddingLeft: "20px",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  useEffect(() => {
    if (params?.accountId === "") {
      setDiscountValue(intialDiscountValue);
    } else {
      if (params?.discount !== null) {
        const discount = { ...params.discount };
        if (discount?.afilliationSelected?.length > 0) {
          const updatedEducationAffiliation = {
            businessEducation:
              discount?.afilliationSelected === "Business Education/Non-profit"
                ? true
                : false,
            businessGovernment:
              discount?.afilliationSelected === "Business Government"
                ? true
                : false,
            businessMilitary:
              discount?.afilliationSelected === "Business Military"
                ? true
                : false,
            businessGeneral:
              discount?.afilliationSelected === "Business General"
                ? true
                : false,
          };
          const updatedDealContract = {
            dealRegistration: discount?.contract.some(
              (x: { contractSelected: string }) =>
                x.contractSelected === "Deal Registration"
            ),
            specialPricing: discount?.contract.some(
              (x: { contractSelected: string }) =>
                x.contractSelected === "Special Pricing"
            ),
            coopPricing: discount?.contract.some(
              (x: { contractSelected: string }) =>
                x.contractSelected === "CO-OP Pricing"
            ),
          };

          const updatedGovernmentNoDiscountGroup = {
            governmentNoDiscount:
              discount?.customerGroup?.governmentDiscountSelected,
            employeePricing: discount?.customerGroup?.employeePricingSelected,
          };

          const updateTaxExemptCheckBox = {
            isTaxExemptChecked: discount.taxExempt.isTaxExemptChecked,
          };
          const coopPricingContractDiscount = discount.contract.find(
            (contract: { contractSelected: string }) =>
              contract.contractSelected === "CO-OP Pricing"
          )?.minimumDiscount;
          const dealRegistrationdate = discount.contract.find(
            (contract: { contractSelected: string }) =>
              contract.contractSelected === "Deal Registration"
          )?.expirationDate;
          const coopPricingdate = discount.contract.find(
            (contract: { contractSelected: string }) =>
              contract.contractSelected === "CO-OP Pricing"
          )?.expirationDate;
          const specialPricingdate = discount.contract.find(
            (contract: { contractSelected: string }) =>
              contract.contractSelected === "Special Pricing"
          )?.expirationDate;
          const taxExpirationdate = discount?.taxExempt?.expirationDate;
          const dealRegistrationExpirationDate =
            dealRegistrationdate?.length > 0
              ? new Date(dealRegistrationdate)
              : undefined;
          const coopPricingExpirationdate =
            coopPricingdate?.length > 0 ? new Date(coopPricingdate) : undefined;
          const specialPricingExpirationdate =
            specialPricingdate?.length > 0
              ? new Date(specialPricingdate)
              : undefined;

          const taxExpirationExpirationdate =
            taxExpirationdate?.length > 0 &&
            discount?.taxExempt?.isTaxExemptChecked
              ? new Date(taxExpirationdate)
              : undefined;

          setDiscountValue({ ...(params.discount as CustomerDiscount) });
          setDealRegistrationExpirationDate(dealRegistrationExpirationDate);
          setcoopPricingExpirationDate(coopPricingExpirationdate);
          setSpecialPricingExpirationDate(specialPricingExpirationdate);
          setTaxExemptExpirationDate(taxExpirationExpirationdate);
          setCustomerGroupCheckBox(updatedGovernmentNoDiscountGroup);
          setCoopMinimumDiscount(coopPricingContractDiscount);
          setAffiliationCheckbox(updatedEducationAffiliation);
          setContractCheckbox(updatedDealContract);
          setTaxExemptCheckBox(updateTaxExemptCheckBox);
          dealRegistrationdate?.length > 0 &&
            setDealRegExpriationDateWarning(
              isExpired(dealRegistrationExpirationDate)
            );
          specialPricingdate?.length > 0 &&
            setSpecialPricingExpriationDateWarning(
              isExpired(specialPricingExpirationdate)
            );
          coopPricingdate?.length > 0 &&
            setCoopPricingExpriationDateWarning(
              isExpired(coopPricingExpirationdate)
            );
          taxExpirationdate?.length > 0 &&
            setTaxExemptExpriationDateWarning(
              isExpired(taxExpirationExpirationdate, true)
            );
          setIsNewQuoteButtonDisabled(false);
          if (
            updatedEducationAffiliation.businessGovernment &&
            updatedGovernmentNoDiscountGroup.governmentNoDiscount
          ) {
            setIsEmployeePricingisabled(true);
          }
        }
      } else {
        setDiscountValue(intialDiscountValue);
      }
    }
  }, []);

  const toggleAffiliation = (e: any, affiliationValue?: string) => {
    switch (affiliationValue) {
      case "Business Education/Non-profit":
        const updatedEducationAffiliation = {
          businessEducation: !affiliationCheckBox.businessEducation,
          businessGovernment: false,
          businessMilitary: false,
          businessGeneral: false,
          businessNonProfit: false,
        };
        if (e.target.checked) {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "Business Education/Non-profit",
            customerGroup: {
              ...customerDiscount.customerGroup,
              governmentDiscountSelected: false,
            },
          });
          setCustomerGroupCheckBox({
            ...customerGroupCheckBox,
            governmentNoDiscount: false,
          });
        } else {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "",
          });
        }
        setAffiliationCheckbox(updatedEducationAffiliation);
        break;

      case "Business Government":
        const updatedGovernmentAffiliation = {
          businessEducation: false,
          businessGovernment: !affiliationCheckBox.businessGovernment,
          businessMilitary: false,
          businessGeneral: false,
          businessNonProfit: false,
        };
        e.target.checked
          ? setDiscountValue({
              ...customerDiscount,
              afilliationSelected: "Business Government",
            })
          : setDiscountValue({ ...customerDiscount, afilliationSelected: "" });
        setAffiliationCheckbox(updatedGovernmentAffiliation);
        break;

      case "Business Military":
        const updatedMilitaryAffiliation = {
          businessEducation: false,
          businessGovernment: false,
          businessMilitary: !affiliationCheckBox.businessMilitary,
          businessGeneral: false,
          businessNonProfit: false,
        };
        if (e.target.checked) {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "Business Military",
            customerGroup: {
              ...customerDiscount.customerGroup,
              governmentDiscountSelected: false,
            },
          });
          setCustomerGroupCheckBox({
            ...customerGroupCheckBox,
            governmentNoDiscount: false,
          });
        } else {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "",
          });
        }
        setAffiliationCheckbox(updatedMilitaryAffiliation);
        break;

      case "Business General":
        const updatedGeneralAffiliation = {
          businessEducation: false,
          businessGovernment: false,
          businessMilitary: false,
          businessGeneral: !affiliationCheckBox.businessGeneral,
          businessNonProfit: false,
        };
        if (e.target.checked) {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "Business General",
            customerGroup: {
              ...customerDiscount.customerGroup,
              governmentDiscountSelected: false,
            },
          });
          setCustomerGroupCheckBox({
            ...customerGroupCheckBox,
            governmentNoDiscount: false,
          });
        } else {
          setDiscountValue({
            ...customerDiscount,
            afilliationSelected: "",
          });
        }
        setAffiliationCheckbox(updatedGeneralAffiliation);
        break;

      default:
        break;
    }
    if (e.target.checked) {
      setIsNewQuoteButtonDisabled(false);
      setCustomerDiscountError({
        ...customerDiscountError,
        afilliationSelected: "",
      });
    } else {
      setIsNewQuoteButtonDisabled(true);
      setCustomerDiscountError({
        ...customerDiscountError,
        afilliationSelected: AFFILATION_REQUIRED,
      });
    }
  };

  const toggleContract = (contractValue: string, e: any) => {
    switch (contractValue) {
      case "Deal Registration":
        const updatedDealContract = {
          dealRegistration: !contractCheckBox.dealRegistration,
          specialPricing: contractCheckBox.specialPricing,
          coopPricing: contractCheckBox.coopPricing,
        };

        if (e?.target.checked) {
          const DealContractValue = {
            contractSelected: contractValue,
            expirationDate: formatDate(dealRegistrationExpirationDate),
            minimumDiscount: "",
          };
          if (dealRegistrationExpirationDate === undefined) {
            setDealRegExpriationDateWarning(
              isExpired(dealRegistrationExpirationDate)
            );
          }
          setDiscountValue({
            ...customerDiscount,
            contract: [...customerDiscount.contract, DealContractValue],
          });
        } else {
          const contract = customerDiscount.contract.filter(
            (x) => x.contractSelected !== "Deal Registration"
          );

          setDiscountValue({
            ...customerDiscount,
            contract: [...contract],
          });
          setDealRegistrationExpirationDate(undefined);
          setDealRegExpriationDateWarning("");
        }
        setContractCheckbox(updatedDealContract);
        break;

      case "Special Pricing":
        const updatedSpecialPricingContract = {
          dealRegistration: contractCheckBox.dealRegistration,
          specialPricing: !contractCheckBox.specialPricing,
          coopPricing: contractCheckBox.coopPricing,
        };
        if (e?.target.checked) {
          const SpecialPricingContractValue = {
            contractSelected: contractValue,
            expirationDate: formatDate(specialPricingExpirationDate),
            minimumDiscount: "",
          };
          if (specialPricingExpirationDate === undefined) {
            setSpecialPricingExpriationDateWarning(
              isExpired(specialPricingExpirationDate)
            );
          }
          setDiscountValue({
            ...customerDiscount,
            contract: [
              ...customerDiscount.contract,
              SpecialPricingContractValue,
            ],
          });
        } else {
          const contract = customerDiscount.contract.filter(
            (x) => x.contractSelected !== "Special Pricing"
          );

          setDiscountValue({
            ...customerDiscount,
            contract: [...contract],
          });
          setSpecialPricingExpirationDate(undefined);
          setSpecialPricingExpriationDateWarning("");
        }
        setContractCheckbox(updatedSpecialPricingContract);
        break;

      case "CO-OP Pricing":
        const updatedCoopPricingContract = {
          dealRegistration: contractCheckBox.dealRegistration,
          specialPricing: contractCheckBox.specialPricing,
          coopPricing: !contractCheckBox.coopPricing,
        };
        if (e?.target.checked) {
          const minimumDiscount =
            coopMinimumDiscount === "" || coopMinimumDiscount === undefined
              ? "10"
              : coopMinimumDiscount;
          setCoopMinimumDiscount("10");
          const CoopPricingContractValue = {
            contractSelected: contractValue,
            expirationDate: formatDate(coopPricingExpirationDate),
            minimumDiscount: minimumDiscount,
          };

          if (coopPricingExpirationDate === undefined) {
            setCoopPricingExpriationDateWarning(
              isExpired(coopPricingExpirationDate)
            );
          }
          setDiscountValue({
            ...customerDiscount,
            contract: [...customerDiscount.contract, CoopPricingContractValue],
          });
        } else {
          const contract = customerDiscount.contract.filter(
            (x) => x.contractSelected !== "CO-OP Pricing"
          );

          setDiscountValue({
            ...customerDiscount,
            contract: [...contract],
          });
          setcoopPricingExpirationDate(undefined);
          setCoopMinimumDiscount("");
          setCoopPricingExpriationDateWarning("");
        }
        setContractCheckbox(updatedCoopPricingContract);
        break;

      default:
        break;
    }
  };

  const toggleCustomerGroup = (customerGroupValue: string, e: any) => {
    const couponCode: string[] = [];
    switch (customerGroupValue) {
      case "Government: No discounts allowed":
        const updatedGovernmentNoDiscountGroup = {
          governmentNoDiscount: !customerGroupCheckBox.governmentNoDiscount,
          employeePricing: false,
        };

        if (e.target.checked) {
          const governmentGroupValue = {
            governmentDiscountSelected:
              !customerGroupCheckBox.governmentNoDiscount,
              couponCode: couponCode,
            employeePricingSelected: false,
          };
          setCustomerGroupCheckBox(updatedGovernmentNoDiscountGroup);
          setIsEmployeePricingisabled(true);
          setDiscountValue({
            ...customerDiscount,
            customerGroup: { ...governmentGroupValue },
          });
        } else {
          setIsEmployeePricingisabled(false);
          const governmentGroupValue = {
            governmentDiscountSelected: false,
            couponCode: couponCode,
            employeePricingSelected: customerGroupCheckBox.employeePricing,
          };
          setDiscountValue({
            ...customerDiscount,
            customerGroup: {
              ...customerDiscount.customerGroup,
              ...governmentGroupValue,
            },
          });
        }
        setCustomerGroupCheckBox(updatedGovernmentNoDiscountGroup);

        break;

      case "Employee Pricing":
        const updatedEmployeePricingGroup = {
          governmentNoDiscount: customerGroupCheckBox.governmentNoDiscount,
          employeePricing: !customerGroupCheckBox.employeePricing,
        };
        if (e?.target.checked) {
          const employeePricingGroupValue = {
            governmentDiscountSelected:
              customerGroupCheckBox.governmentNoDiscount,
            couponCode: couponCode,
            employeePricingSelected: !customerGroupCheckBox.employeePricing,
          };
          setDiscountValue({
            ...customerDiscount,
            customerGroup: {
              ...customerDiscount.customerGroup,
              ...employeePricingGroupValue,
            },
          });
        } else {
          const employeePricingGroupValue = {
            employeePricingSelected: false,
            governmentDiscountSelected:
              customerGroupCheckBox.governmentNoDiscount,
            couponCode: couponCode,
          };
          setDiscountValue({
            ...customerDiscount,
            customerGroup: {
              ...customerDiscount.customerGroup,
              ...employeePricingGroupValue,
            },
          });
        }
        setCustomerGroupCheckBox(updatedEmployeePricingGroup);
        break;
      default:
        break;
    }
  };

  const toggleTaxExempt = (e: any) => {
    if (e.target.checked) {
      const taxExemptChecked = {
        isTaxExemptChecked: true,
        expirationDate: formatDate(taxExemptExpirationDate),
        taxExemptReason: customerDiscount.taxExempt.taxExemptReason,
      };
      setDiscountValue({
        ...customerDiscount,
        taxExempt: { ...taxExemptChecked },
      });
      if (taxExemptExpirationDate === undefined) {
        setTaxExemptExpriationDateWarning(
          isExpired(taxExemptExpirationDate, true)
        );
      }
    } else {
      setDiscountValue({
        ...customerDiscount,
        taxExempt: {
          ...customerDiscount.taxExempt,
          isTaxExemptChecked: false,
          expirationDate: "",
          taxExemptReason: "",
        },
      });
      setTaxExemptExpirationDate(undefined);
      setTaxExemptExpriationDateWarning("");
      setIsTaxExemptReasonSelected(false);
    }
    setTaxExemptCheckBox({ isTaxExemptChecked: e.target.checked });
  };
  const handleItemSubmit = async (e: Event, isNewQuote: boolean) => {
    setLoader({
      isLoading: true,
      message: "Saving details...",
    });

    e.preventDefault();
    const { isValidated, customerDiscountErrors } =
      validateCustomerDiscountSetupFields(customerDiscount);
    if (isValidated && params) {
      isNewQuote
        ? setIsNewQuoteButtonDisabled(true)
        : setIsSaveButtonDisabled(true);
      params.discount = customerDiscount;
      if (!customerDiscount.taxExempt.isTaxExemptChecked) {
        params.discount.taxExempt.expirationDate = "";
      }
      setCustomerSuccessMessage({
        message: ``,
        showMessage: false,
      });
      setCustomerFailureMessage({
        message: ``,
        showMessage: false,
      });
      await CustomerService.updateCustomerAccount(params)
        .then((res) => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          if (res !== undefined) {
            if (res?.data?.code == 200) {
              setCustomerSuccessMessage({
                message: `Customer updated successfully`,
                showMessage: true,
              });
              setTimeout(() => {
                console.log("Value of is New quote", isNewQuote);
                if (isNewQuote) {
                  setQuotationError({
                    ...ErrorsDefaultState,
                  });
                  setQuotationInfo({
                    ...InitialQuotationInfo,
                    quoteLineItems: [],
                    quoteLineItemsClone: [],
                    standaloneItems: [],
                    standaloneItemsClone: [],
                    bundleItems: [],
                    bundleItemsClone: [],
                  });
                  navigate("/AddQuotation", {
                    state: {
                      ...params,
                      actionName: NEW_ACTION,
                      customerId: params.accountId,
                    },
                  });
                  setLoader({
                    isLoading: false,
                    message: "",
                  });
                } else {
                  navigate("/Customer", { state: { isSubmitClick: true } });
                  setLoader({
                    isLoading: false,
                    message: "",
                  });
                }
              }, 3000);
            } else if (res?.data?.code == 400) {
              setIsNewQuoteButtonDisabled(false);
              setIsSaveButtonDisabled(false);
              const dataMessage = res?.data?.message;
              setCustomerFailureMessage({
                message: dataMessage?.split("\n").join(", "),
                showMessage: true,
              });
              setIsSaveButtonDisabled(false);
              setLoader({
                isLoading: false,
                message: "",
              });
            }
          }
        })
        .catch((error) => {
          appInsights.trackException({
            error: new Error(error as string),
            properties: {
              name: "Error in Update Customer API in DiscountSetup.tsx",
            },
          });

          setIsNewQuoteButtonDisabled(false);
          setIsSaveButtonDisabled(false);
          setLoader({
            isLoading: false,
            message: "",
          });
        });
    } else {
      setCustomerDiscountError({
        ...customerDiscountErrors,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const _OnClickCancelAction = () => {
    navigate("/Customer");
  };

  return (
    <Stack>
      <Stack
        verticalFill
        verticalAlign="start"
        tokens={stackTokensWithGap20}
        style={{ backgroundColor: "#FAF9F8" }}
      >
        {customerSuccessMessage.showMessage && (
          <MessageBar
            messageBarType={MessageBarType.success}
            onDismiss={() =>
              setCustomerSuccessMessage(InitialStateOfResponseMessage)
            }
          >
            {customerSuccessMessage.message}
          </MessageBar>
        )}
        {customerFailureMessage.showMessage && (
          <MessageBar
            messageBarType={MessageBarType.error}
            onDismiss={() =>
              setCustomerFailureMessage(InitialStateOfResponseMessage)
            }
          >
            {customerFailureMessage.message}
          </MessageBar>
        )}
        <Breadcrumb
          items={getBreadcrumbItems()}
          style={{ marginLeft: "1%", marginBottom: "-5px" }}
          styles={BreadcrumbStyle}
        />
        {/* <Label
            style={{
              paddingTop: "10px",
              paddingBottom: "10px",
              fontSize: FontSizes.size28,
              fontWeight: FontWeights.semibold,
            }}
          >
            <Label
              style={{ marginLeft: "15px", fontSize: "15px", display: "inline" }}
            >
              {`Customers > New Account`}{" "}
            </Label>
          </Label> */}
        <Stack horizontal tokens={{ childrenGap: 50 }}>
          <Card>
            {params?.name && (
              <h1
                style={{
                  fontSize: FontSizes.size18,
                  display: "inline",
                  fontWeight: FontWeights.bold,
                }}
              >
                Discount Eligibility
              </h1>
            )}
          </Card>
        </Stack>

        {loader?.isLoading ? (
          <div style={LoadingContainerStyle}>
            <LoadingState primaryText={loader.message} styles={{}} />
          </div>
        ) : (
          <Stack style={{ overflowY: "auto" }}>
            <Stack horizontal style={cardSize}>
              <Card header={<CardStandardHeader cardTitle="Affiliation" />}>
                <Card
                  header={
                    <Label style={cardStyle}>
                      {" "}
                      <Icon iconName={"Info"} />
                      <p
                        style={{
                          display: "inline",
                          fontSize: "14px",
                          fontWeight: "350",
                          marginLeft: "2px",
                        }}
                      >
                        Affiliations are the main indicator to determine if the
                        customer is eligible for Education and/or Non-profit
                        discounts applied. Government, Military and General
                        affiliations are not eligible for Education and
                        Non-Profit specific discounts.
                      </p>
                    </Label>
                  }
                >
                  <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        color: "rgb(164, 38, 44)",
                      }}
                    >
                      {customerDiscountError.afilliationSelected}
                    </p>
                    <p style={{ marginTop: "15px" }}></p>
                    <Checkbox
                      ariaLabel="Business Education/Non-profit"
                      disabled={true}
                      label="Business Education/Non-profit"
                      checked={affiliationCheckBox.businessEducation}
                    />
                    <Checkbox
                      disabled={true}
                      ariaLabel="Business Government"
                      label="Business Government"
                      checked={affiliationCheckBox.businessGovernment}
                    />
                    <Checkbox
                      disabled={true}
                      ariaLabel="Business Military"
                      label="Business Military"
                      checked={affiliationCheckBox.businessMilitary}
                    />
                    <Checkbox
                      disabled={true}
                      ariaLabel="Business General"
                      label="Business General"
                      checked={affiliationCheckBox.businessGeneral}
                    />
                  </Stack>
                </Card>
              </Card>
            </Stack>

            <Stack horizontal style={cardSize}>
              <Card
                header={<CardStandardHeader cardTitle="Customer Contracts" />}
              >
                <Card
                  styles={{ layout: { height: "280px" } }}
                  header={
                    <Label style={cardStyle}>
                      <Icon iconName={"Info"} />
                      <p
                        style={{
                          display: "inline",
                          fontSize: "14px",
                          fontWeight: "350",
                          marginLeft: "2px",
                        }}
                      >
                        Customers can have unique agreements and approved
                        contracts to buy specific sku's in volume at a
                        percentage off discount. If applicable, check the box
                        and fill the expiration date. Checked contracts will be
                        applied automatically in best price calculation.
                      </p>
                    </Label>
                  }
                >
                  <Stack verticalAlign="center" tokens={{ childrenGap: 30 }}>
                    <p style={{ marginTop: "15px", marginBottom: "-15px" }}>
                      Select all customer contracts that are applicable
                    </p>
                    <Stack verticalAlign="center">
                      <Checkbox
                        onChange={(e) => {
                          toggleContract("Deal Registration", e);
                        }}
                        label="Deal Reg Expiration Date"
                        ariaLabel="Deal Reg Expiration Date"
                        checked={contractCheckBox.dealRegistration}
                        styles={CheckBoxStyles}
                      />
                      <DatePicker
                        placeholder="Select date"
                        role="dialog"
                        ariaLabel="Deal Registration"
                        styles={DiscountCalendarStyles}
                        onSelectDate={(date: Date | null | undefined) => {
                          if (date) {
                            setDealRegistrationExpirationDate(date);
                            setDealRegExpriationDateWarning(isExpired(date));
                            const contractValues = customerDiscount.contract.map(
                              (selectedContract) => {
                                if (selectedContract.contractSelected === "Deal Registration") {
                                  return {
                                    ...selectedContract,
                                    expirationDate: formatDateToMMDDYYYY(date),
                                  };
                                }
                                return selectedContract;
                              }
                            );
                            setDiscountValue({ ...customerDiscount, contract: contractValues });
                          }
                        }}
                        showCloseButton
                        showGoToToday
                        formatDate={formatDate}
                        value={dealRegistrationExpirationDate}
                        disabled={!contractCheckBox.dealRegistration}
                        minDate={new Date()}
                      />
                    </Stack>
                    {dealRegExpriationDateWarning !== "" && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color:
                            dealRegExpriationDateWarning === warningMessage ||
                            dealRegExpriationDateWarning === expirationMessage
                              ? "rgb(164, 38, 44)"
                              : "rgb(0, 120, 212)",
                          marginLeft: "32px",
                          marginTop: "15px",
                          marginBottom: "-15px",
                        }}
                      >
                        {dealRegExpriationDateWarning}
                      </span>
                    )}
                    <Stack verticalAlign="center">
                      <Checkbox
                        onChange={(e) => {
                          toggleContract("Special Pricing", e);
                        }}
                        ariaLabel="Special Pricing Expiration Date"
                        label="Special Pricing Expiration Date"
                        checked={contractCheckBox.specialPricing}
                        styles={CheckBoxStyles}
                      />
                      <DatePicker
                        placeholder="Select date"
                        styles={DiscountCalendarStyles}
                        ariaLabel="Special Pricing"
                        onSelectDate={(date: Date | null | undefined) => {
                          if (date) {
                            setSpecialPricingExpirationDate(date);
                            setSpecialPricingExpriationDateWarning(isExpired(date));
                            const contractValues = customerDiscount.contract.map(
                              (selectedContract) => {
                                if (selectedContract.contractSelected === "Special Pricing") {
                                  return {
                                    ...selectedContract,
                                    expirationDate: formatDateToMMDDYYYY(date),
                                  };
                                }
                                return selectedContract;
                              }
                            );
                            setDiscountValue({ ...customerDiscount, contract: contractValues });
                          }
                        }}
                        showCloseButton
                        showGoToToday
                        formatDate={formatDate}
                        value={specialPricingExpirationDate}
                        disabled={!contractCheckBox.specialPricing}
                        minDate={new Date()}
                      />
                    </Stack>
                    {specialPricingExpriationDateWarning !== "" && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color:
                            specialPricingExpriationDateWarning ===
                              warningMessage ||
                            specialPricingExpriationDateWarning ===
                              expirationMessage
                              ? "rgb(164, 38, 44)"
                              : "rgb(0, 120, 212)",
                          marginLeft: "32px",
                          marginTop: "15px",
                          marginBottom: "-15px",
                        }}
                      >
                        {specialPricingExpriationDateWarning}
                      </span>
                    )}
                    <Stack verticalAlign="center">
                      <Checkbox
                        onChange={(e) => {
                          toggleContract("CO-OP Pricing", e);
                        }}
                        label="CO-OP Pricing Expiration Date"
                        ariaLabel="CO-OP Pricing Expiration Date"
                        checked={contractCheckBox.coopPricing}
                        styles={CheckBoxStyles}
                      />
                      <DatePicker
                        placeholder="Select date"
                        ariaLabel="CO-OP Pricing"
                        styles={DiscountCalendarStyles}
                        onSelectDate={(date: Date | null | undefined) => {
                          if (date) {
                            setcoopPricingExpirationDate(date);
                            setCoopPricingExpriationDateWarning(isExpired(date));
                            const contractValues = customerDiscount.contract.map(
                              (selectedContract) => {
                                if (selectedContract.contractSelected === "CO-OP Pricing") {
                                  return {
                                    ...selectedContract,
                                    expirationDate: formatDateToMMDDYYYY(date),
                                  };
                                }
                                return selectedContract;
                              }
                            );
                            setDiscountValue({ ...customerDiscount, contract: contractValues });
                          }
                        }}
                        showCloseButton
                        showGoToToday
                        formatDate={formatDate}
                        value={coopPricingExpirationDate}
                        disabled={!contractCheckBox.coopPricing}
                        minDate={new Date()}
                      />
                    </Stack>
                    {coopPricingExpriationDateWarning !== "" && (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "400",
                          color:
                            coopPricingExpriationDateWarning ===
                              warningMessage ||
                            coopPricingExpriationDateWarning ===
                              expirationMessage
                              ? "rgb(164, 38, 44)"
                              : "rgb(0, 120, 212)",
                          marginLeft: "32px",
                          marginTop: "15px",
                          marginBottom: "-15px",
                        }}
                      >
                        {coopPricingExpriationDateWarning}
                      </span>
                    )}
                  </Stack>
                  <Stack
                    horizontal
                    style={{
                      marginLeft: "300px",
                      marginTop:
                        coopPricingExpriationDateWarning !== ""
                          ? "-50px"
                          : "-35px",
                    }}
                  >
                    <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                      <span
                        id="minimumDiscountLabel"
                        style={{ fontWeight: FontWeights.semibold }}
                      >
                        Minimum Discount %{" "}
                      </span>
                      <ComboBox
                        id="minimumDiscount"
                        aria-label="Minimum Discount"
                        aria-labelledby="minimumDiscountLabel"
                        role="combobox"
                        aria-expanded="true"
                        aria-controls="minimumDiscount"
                        styles={DiscountComboBoxStyles}
                        options={minumDiscountOptions}
                        selectedKey={coopMinimumDiscount}
                        disabled={!minimumDiscountEnabled}
                        onChange={(e, discountValue) => {
                          setCoopMinimumDiscount(
                            discountValue?.key.toString() || ""
                          );
                          const updatedArray = customerDiscount.contract.map(
                            (coop) => {
                              if (coop.contractSelected === "CO-OP Pricing") {
                                return {
                                  ...coop,
                                  minimumDiscount:
                                    discountValue?.key.toString() || "",
                                };
                              }
                              return coop;
                            }
                          );
                          setDiscountValue({
                            ...customerDiscount,
                            contract: [...updatedArray],
                          });
                        }}
                      />
                    </Stack>
                  </Stack>
                </Card>
              </Card>
            </Stack>

            <Stack horizontal style={cardSize}>
              <Card
                header={
                  <CardStandardHeader cardTitle="Customer Group Agreements" />
                }
              >
                <Card
                  header={
                    <Label style={cardStyle}>
                      {" "}
                      <Icon iconName={"Info"} />
                      <p
                        style={{
                          display: "inline",
                          fontSize: "14px",
                          fontWeight: "350",
                          marginLeft: "2px",
                        }}
                      >
                        Customers have unique agreements for additional
                        promotional percentage off discounts and/or customers
                        are restricted from having any discounts applied.
                      </p>
                    </Label>
                  }
                >
                  <Stack verticalAlign="center" tokens={{ childrenGap: 20 }}>
                    <p style={{ marginBottom: "15px" }}>
                      {" "}
                      Select all that apply to this customer
                    </p>
                  </Stack>

                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <Stack
                      verticalAlign="center"
                      tokens={{ childrenGap: "10px" }}
                    >

                      <Checkbox
                        onChange={(e) => {
                          toggleCustomerGroup("Employee Pricing", e);
                        }}
                        ariaLabel="Employee Pricing"
                        label="Employee Pricing"
                        checked={customerGroupCheckBox.employeePricing}
                        disabled={isEmployeePricingDisabled}
                      />
                      <Checkbox
                        onChange={(e) => {
                          toggleCustomerGroup(
                            "Government: No discounts allowed",
                            e
                          );
                        }}
                        ariaLabel="Government: No discounts allowed"
                        label="Government: No discounts allowed"
                        checked={customerGroupCheckBox.governmentNoDiscount}
                        disabled={isGovernmentExcludedDisabled}
                      />
                    </Stack>

                  </Stack>
                </Card>
              </Card>
            </Stack>

            <Stack horizontal style={cardSize}>
              <Card header={<CardStandardHeader cardTitle="Tax Exempt" />}>
                <Card styles={{ layout: { height: "120px" } }}>
                  <Stack
                    horizontal
                    style={{ marginTop: "-5px" }}
                    tokens={{ childrenGap: 5 }}
                  >
                    <Stack verticalAlign="center">
                      <Checkbox
                        onChange={(e) => {
                          toggleTaxExempt(e);
                        }}
                        ariaLabel="Expiration Date"
                        label="Expiration Date"
                        checked={taxExemptCheckBox.isTaxExemptChecked}
                        styles={CheckBoxStyles}
                      />
                      <DatePicker
                        placeholder="Select date"
                        ariaLabel="Tax Exempt"
                        styles={DiscountCalendarStyles}
                        onSelectDate={(date: Date | null | undefined) => {
                          if (date) {
                            setTaxExemptExpirationDate(date);
                            setTaxExemptExpriationDateWarning(isExpired(date, true));
                            setIsTaxExemptReasonSelected(true);
                            setDiscountValue({
                              ...customerDiscount,
                              taxExempt: {
                                ...customerDiscount.taxExempt,
                                expirationDate: formatDateToMMDDYYYY(date),
                              },
                            });
                          }
                        }}
                        showCloseButton
                        showGoToToday
                        formatDate={formatDate}
                        value={taxExemptExpirationDate}
                        disabled={!taxExemptCheckBox.isTaxExemptChecked}
                        minDate={new Date()}
                      />
                      <>
                        {taxExemptExpriationDateWarning !== "" && (
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: "400",
                              color:
                                taxExemptExpriationDateWarning ===
                                warningMessage
                                  ? "rgb(164, 38, 44)"
                                  : "rgb(0, 120, 212)",
                              marginLeft: "32px",
                              marginTop: "16px",
                              marginBottom: "-30px",
                            }}
                          >
                            {taxExemptExpriationDateWarning}
                          </span>
                        )}
                      </>
                    </Stack>

                    <Stack
                      verticalAlign="center"
                      style={{ marginLeft: "30px", marginTop: "16px" }}
                      tokens={{ childrenGap: 11 }}
                    >
                      <span
                        id="reasonLabel"
                        style={{
                          fontWeight: FontWeights.semibold,
                        }}
                      >
                        Reason{" "}
                      </span>
                      <ComboBox
                        aria-label="Reason"
                        aria-labelledby="reasonLabel"
                        placeholder="Selected Reason"
                        id="selectedReason"
                        role="combobox"
                        aria-expanded="true"
                        aria-controls="selectedReason"
                        styles={ComboBoxStyles}
                        options={taxExemptReasonsOptions}
                        selectedKey={
                          customerDiscount?.taxExempt.taxExemptReason
                        }
                        onChange={(e, taxExemptReasonValue) => {
                          if (taxExemptReasonValue !== undefined) {
                            setIsTaxExemptReasonSelected(false);
                            setDiscountValue({
                              ...customerDiscount,
                              taxExempt: {
                                ...customerDiscount.taxExempt,
                                taxExemptReason:
                                  taxExemptReasonValue.text.toString(),
                              },
                            });
                          }
                        }}
                      />
                      {isTaxExemptReasonSelected && (
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "rgb(164, 38, 44)",
                            marginBottom: "-15px",
                          }}
                        >
                          {"No Tax Exempt Reason is selected"}
                        </span>
                      )}
                    </Stack>
                  </Stack>
                </Card>
              </Card>
            </Stack>

            <Stack
              horizontal
              horizontalAlign="center"
              style={cardSize}
              tokens={{ childrenGap: 30 }}
            >
              <PrimaryButton
                text="Cancel"
                type="button"
                onClick={_OnClickCancelAction}
                style={EditScreenButtonStyle}
                disabled={isSaveButtonDisabled}
              />
              <PrimaryButton
                text="Save & Close"
                type="button"
                disabled={
                  isSaveButtonDisabled ||
                  isNewQuoteButtonDisabled ||
                  isExpirationDateMissing ||
                  isTaxExemptReasonSelected
                }
                onClick={(e: any) => handleItemSubmit(e, false)}
                style={CreateQuoteStyle}
              />
              <PrimaryButton
                text="Save & Create Quotation"
                type="button"
                disabled={
                  isSaveButtonDisabled ||
                  isNewQuoteButtonDisabled ||
                  isExpirationDateMissing ||
                  isTaxExemptReasonSelected
                }
                onClick={(e: any) => handleItemSubmit(e, true)}
                style={CreateQuoteStyle}
              />
            </Stack>
          </Stack>
        )}
      </Stack>
      {/* {showErrorAlert && (
          <MessageBar delayedRender={false} messageBarType={MessageBarType.error}>
            {ErrorMessage}
          </MessageBar>
        )} */}
    </Stack>
  );
};
